import React, { useEffect, useState } from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import { useForm } from 'react-final-form';
import { FileField, FileInput, useNotify } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import httpClient from '../../core/httpClient';
import { serverApiUrl } from '../../config/constants';
import { fileUploadStyles } from './styles';

const useStyles = makeStyles(fileUploadStyles);

const FilePreview = ({ source, title, record }) => (
  <>
    <DescriptionIcon style={{ fontSize: 40, verticalAlign: 'middle', marginRight: 8 }} />
    <FileField record={record} source={source} title={title} target="_blank" />
  </>
);

const UploadFileInput = ({
  label = '',
  buttonText = 'Upload File',
  fileInputSource,
  fileDropSource,
  filePreviewSource = 'url',
  uploadType,
  ...rest
}) => {
  const form = useForm();
  const notify = useNotify();
  const classes = useStyles();
  const [filePreview, setFilePreview] = useState();

  useEffect(() => {
    const loadFilePreview = () => {
      const fileKey = form.getFieldState(fileInputSource)?.value;

      if (typeof fileKey !== 'string' || !fileKey) {
        setFilePreview(undefined);
        return;
      }

      const url = `${serverApiUrl}/services/file?file_key=${fileKey}`;
      const options = { method: 'GET' };

      httpClient(url, options)
        .then((res) => {
          setFilePreview(res.json.url);
        })
        .catch(() => {
          setFilePreview(undefined);
        });
    };

    loadFilePreview();

    const timeoutId = setTimeout(loadFilePreview, 100);

    return () => clearTimeout(timeoutId);
  }, [fileInputSource, form]);

  const uploadFile = (file) => {
    if (!uploadType) {
      notify('Error: Unsupported upload target', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('file', file[0]);
    formData.append('upload_type', uploadType);
    const url = `${serverApiUrl}/admin/services/file`;
    const options = { method: 'POST', body: formData };

    httpClient(url, options)
      .then((res) => {
        form.change(fileInputSource, res.json.file_key);
        setFilePreview(res.json.url);
        if (fileDropSource) {
          form.change(fileDropSource, null);
        }
      })
      .catch(() => {
        notify("Error: File wasn't sent", 'warning');
      });
  };

  const formatFunc = (value) => {
    if (typeof value === 'string') {
      return {
        [filePreviewSource]: filePreview || value,
        name: value.split('/').pop() || value,
      };
    }

    return value;
  };

  return (
    <FileInput
      classes={{ dropZone: classes.dropZone, removeButton: classes.removeButton, root: classes.root }}
      source={fileDropSource || fileInputSource}
      format={formatFunc}
      label={label}
      placeholder={<span>{buttonText}</span>}
      options={{ onDropAccepted: uploadFile }}
      {...rest}
    >
      <FilePreview source={filePreviewSource} title="name" />
    </FileInput>
  );
};

export default UploadFileInput;
